<template>
    <div class="uk-width-1-1">
        <div
            :class="{ 'lam-overridable': (record.title === null) }"
            class="lam-in-field-button uk-flex uk-flex-middle overridable-field"
        >
            <form-input
                v-if="editing"
                :id="`phase-title-${record.id}`"
                v-model="title"
                name="title"
                :error="has_error('title')"
                :required="false"
                :editable="editable"
                :placeholder="standardized_title(true)"
                @keyup.stop="maybe_save_title"
                class="uk-flex-item-1 uk-margin-right"
            />
            <form-input
                v-else
                :id="`phase-title-${record.id}`"
                :value="standardized_title()"
                name="title"
                :required="false"
                :editable="false"
                class="uk-flex-item-1 uk-margin-right"
            />
            <a
                v-if="editable && (standardized_title() !== standardized_title(true))"
                href
                class="uk-icon-hover uk-icon-refresh overridable-field-button uk-flex-item-none"
                @click.prevent="reset_title"
            ></a>
            <a
                v-if="editable"
                href
                :class="{ 'uk-icon-pencil': !editing, 'uk-icon-close': !!editing }"
                class="uk-icon-hover overridable-field-button uk-flex-item-none"
                @click.prevent="toggle_editing"
            ></a>
            <a
                v-if="editable && editing"
                href
                class="uk-icon-hover uk-icon-save overridable-field-button uk-flex-item-none"
                @click.prevent="save_title"
            ></a>
        </div>
        <!--
        <overridable-field
            entity="phase"
            name="title"
            :value="record.title"
            :editable="editable"
            :computed-value="standardized_title(true)"
            @override="save_field"
            class="uk-width-1-1"
        >
        </overridable-field>
        //-->
        <slot name="subtitle" :title="standardized_title(true)">
            <div v-if="!!record.title" class="uk-text-small uk-text-muted">
                ({{ standardized_title(true) }})
            </div>
        </slot>
    </div>
</template>

<script type="text/javascript">
import handles_saving from "../../../mixins/HandlesSaving"
import phase_utilities from "../../../mixins/PhaseUtilities"

import FormInput from "../../../ui/FormInput"

export default {
    mixins: [handles_saving, phase_utilities],
    components: {
        FormInput
    },
    mounted () {
        this.reset_record_id()
    },
    watch: {
        "record.id": "reset_record_id"
    },
    methods: {
        reset_record_id () {
            this.record_id = this.record ? this.record.id : 0
        },
        standardized_title (raw = false) {
            return this.phase_standardized_title(this.record, raw)
        },
        toggle_editing () {
            if(!this.editing) {
                if(this.record.title) this.title = this.record.title
                else this.title = this.standardized_title(true)
            }
            this.editing = !this.editing
        },
        save_title () {
            this.record.title = this.title
            this.save_field(this.title, "title")
            this.editing = false
        },
        maybe_save_title (event) {
            this.title = event.target.value
            if(event && (event.code === "Enter")) this.save_title()
        },
        reset_title () {
            this.record.title = null
            this.save_field(null, "title")
            this.editing = false
        }
    },
    computed: {
        missing () {
            return !this.record.starts_at || !this.record.ends_at || (this.record.fee <= 0)
        }
    },
    props: {
        record: {
            type: Object,
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            record_id: 0,
            entity: "phase",
            title: "",
            editing: false
        }
    }
}
</script>
